import { render, staticRenderFns } from "./addNewsAnnouncement.vue?vue&type=template&id=087e1dd4&scoped=true"
import script from "./addNewsAnnouncement.vue?vue&type=script&lang=js"
export * from "./addNewsAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./addNewsAnnouncement.vue?vue&type=style&index=0&id=087e1dd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e1dd4",
  null
  
)

export default component.exports